import React from 'react';
import { ModalBody, ModalButton, ModalContainer, ModalFooter, ModalHeader, ModalOverlay, ModalText, ModalTitle } from './styles';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  selectedImagesCount: number;
}

const DeleteConfirmationModal: React.FC<ModalProps> = ({ isOpen , onClose, onConfirm , selectedImagesCount }) => {
  if (!isOpen) return null;
  var deleteMessage='Are you sure you want to delete all images?';
  if (selectedImagesCount > 0) deleteMessage = `Are you sure you want to delete ${selectedImagesCount} image${selectedImagesCount > 1 ? 's' : ''}?`;
  return (
    <ModalOverlay>
      <ModalContainer>
        <ModalHeader>Multiple Delete</ModalHeader>
        <ModalBody>
          {deleteMessage}<br/>
          This action cannot be undone.
        </ModalBody>
        <ModalFooter>
          <ModalButton className="cancel" onClick={onClose}>Cancel</ModalButton>
          <ModalButton className="delete" onClick={onConfirm}>Delete</ModalButton>
        </ModalFooter>
      </ModalContainer>
    </ModalOverlay>
  );
};

export default DeleteConfirmationModal;
